import { useGetFeedback } from '../../api/ues-get-feedback';
import { useGetReleaseIdFromParams } from '../../hooks/use-get-release-id-from-params/use-get-release-id-from-params';
import { ReleaseLayout } from '../../components/layout/release-layout';
import { InfoMessage } from '../../components/error-message/info-message';

export const PromoFeedbackPage = () => {
  const releaseId = useGetReleaseIdFromParams();
  const { data, isLoading, isSuccess } = useGetFeedback(releaseId);

  return (
    <ReleaseLayout>
      <div className="min-h-[70vh] py-8">
        {isLoading && <InfoMessage text="Loading..." />}
        {isSuccess && data && data.length > 0 ? (
          <div className="flex flex-col items-center gap-4">
            <p className="text-sm">
              <span className="font-bold">Responses:</span> {data.length}
            </p>
            {data.map((item) => (
              <div className="bg-card p-4 w-full md:max-w-[600px]">
                <div className="flex justify-between">
                  <p className="text-xl font-bold">{item.artistName}</p>
                  {item.createdAt && (
                    <p className="text-sm">
                      {item.createdAt.replace('T', ' ')}
                    </p>
                  )}
                </div>
                <p className="italic my-2">{item.content}</p>
                <p className="text-sm">
                  <span className="font-bold">Rating:</span> {item.rating}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <InfoMessage text="No feedback received yet" />
        )}
      </div>
    </ReleaseLayout>
  );
};
